import React from 'react'
import styled from 'styled-components'
import { Link as BaseLink } from 'docz'

const CrumbLinkBox = styled.div`
  display: flex;
  align-items: center;
`

const Link = styled(BaseLink)`
  font-size: 14px;
  padding: 2px 0;
  color: rgb(76, 85, 90);
  line-height: 1.5em;

  &,
  &:visited {
    color: ${p => p.theme.colors.grayDark};
  }

  &.active,
  &:hover {
    color: ${p => p.theme.colors.primary};
  }
`

const NotLink = styled.span`
  font-size: 14px;
  color: ${p => p.theme.colors.grayDark};
`

const CrumbGroup = styled.div`
  display: flex;
  align-items: center;
`

const Divider = styled.div`
  position: relative;
  top: -2px;
  font-size: 10px;
  line-height: 10px;
  margin: 0 10px;
`

export const Crumb = ({ crumbs }: any) => {
  return (
    <CrumbLinkBox>
      {crumbs.map((crumb: any, index: number) => {
        return (
          <CrumbGroup key={index}>
            {index !== 0 && <Divider>/</Divider>}
            {crumb.route ? (
              <Link
                to={crumb.route}
                className={
                  crumb.route.split('?')[0] === location.pathname
                    ? 'active'
                    : ''
                }
              >
                {crumb.label}
              </Link>
            ) : (
              <NotLink>{crumb.label}</NotLink>
            )}
          </CrumbGroup>
        )
      })}
    </CrumbLinkBox>
  )
}
